import {ChangeDetectorRef, Component, ElementRef, Inject, LOCALE_ID, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {NumberFieldConfig} from '../number-field.config';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {NumberTypeEnum} from '../number-type.enum';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MediaQueryService} from '@mydocma/core';
import {NumberPickerComponent} from '../number-picker/number-picker.component';
import {getLocaleNumberSymbol, NumberSymbol} from '@angular/common';
import {NG_VALUE_ACCESSOR} from '@angular/forms';


@Component({
    selector: 'mydocma-form-number-field',
    templateUrl: './number-field.component.html',
    styleUrls: ['./number-field.component.scss'],
    providers: [
        MediaQueryService,
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: NumberFieldComponent
        }
    ]
    // entryComponents: []
})
export class NumberFieldComponent extends BaseFieldComponent<NumberFieldConfig> {
    public numberType = NumberTypeEnum;

    public readonly staticCssClass = 'mydocma-number-field';
    private localDecimal = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2,
        public dialog: MatDialog,
        public mediaQueryService: MediaQueryService,
        @Inject(LOCALE_ID) public locale: string
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);

    }

    public onBlur(): void {
        this.eventDispatcher.notifyControlBlur(this.fieldWrapper.config);

    }

    public openNumberPicker(): void {
        const dialogRef = this.dialog.open(NumberPickerComponent,
            {
                panelClass: 'mydocma-number-picker-dialog',
                disableClose: true,
                autoFocus: false,
                data: {
                    value: Math.trunc((this.control.value)),
                    maxValue: this.fieldWrapper.config?.maxValue,
                    minValue: this.fieldWrapper.config?.minValue
                }
            },
        );

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.control.setValue(result);
            }
        });
    }

    public onClick(): void {
        if (this.mediaQueryService.isXs &&
            this.fieldWrapper.config?.incrementButtons &&
            this.fieldWrapper.config?.numberType === NumberTypeEnum.integer &&
            !this.fieldWrapper.config.readonly) {
            this.openNumberPicker();
        }

        if (this.fieldWrapper.config.readonly) {
            return;
        }

        super.onControlClick();
    }

    public setIncrementValue(type: 'increment' | 'decrement', value: number): void {
        const currentValue = parseFloat(this.control.value.toString())
        if (type === 'increment' && value <= this.fieldWrapper.config?.maxValue || (!this.fieldWrapper.config?.maxValue && type === 'increment')) {
            this.control.setValue(currentValue + 1);
        }
        if (type === 'decrement' && value >= this.fieldWrapper.config?.minValue || (!this.fieldWrapper.config?.minValue && type === 'decrement')) {
            this.control.setValue(currentValue - 1);
        }
    }

    public onKeyPress(e: KeyboardEvent): boolean {
        const currentValue = this.control.value?.toString() || '';
        const allowNegativeNumbers = (this.fieldWrapper.config?.minValue >= 0);
        if (((!e.shiftKey && e.key === '-' && !allowNegativeNumbers))
            && (e.target as any).selectionStart === 0) {
            return true
        }
        if ((e.key === ',' || e.key === '.')
            && (NumberTypeEnum.decimal === this.fieldWrapper.config.numberType || NumberTypeEnum.currency === this.fieldWrapper.config.numberType || !this.fieldWrapper.config?.numberType)
            && Number.isInteger(parseFloat(currentValue))) {
            return true;
        }
        return !(/[^0-9]/g).test(e.key);

    }

    blur() {
        return false
    }

}
